<script>
import { mapGetters } from 'vuex'
import ButtonToggle from '@/components/atoms/ButtonToggle'

export default {
    name: 'SetDelivery',
    components: { ButtonToggle },
    data() {
        return {
            setDeliveryDetails: [
                {
                    value: false,
                    label: this.$t('labels.pickup'),
                },
                {
                    value: true,
                    label: this.$t('labels.delivery'),
                },
            ],
        }
    },
    computed: {
        ...mapGetters({ isDelivery: 'order/isDelivery' }),
    },
    methods: {
        setDelivery(val) {
            this.$store.dispatch('order/setDelivery', val)
        },
    },
}
</script>

<template lang="pug">
button-toggle(:value="isDelivery" @input="setDelivery" :data="setDeliveryDetails")
</template>
